import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$window, $body} from '../Constants';

/**
 * Search
 */
class Search extends HtmlElement {
    onReady() {
        this.$searchInput = this.$element.find('#tx-indexedsearch-searchbox-sword');
        this.$toggleInput = this.$element.parent().find('input#toggle-search');
        this.$toggleLabel = this.$toggleInput.next('label.toggle-search');

        this.bindHandlers();

        if(this.$searchInput.val().length > 0) {
            this.$toggleInput.prop('checked', true);
        }
    }

    bindHandlers() {
        this.$toggleLabel.on('click', () => {
            if(this.$toggleInput.prop('checked') === false) {
                setTimeout(() => {
                    this.$searchInput.focus();
                }, 300);
            }else {
                this.$searchInput.blur();
            }
        });
    }
}

export default (new Search($body.find('#header .tx-indexedsearch-searchbox')));